import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { RoadmapTimeline, RoadmapTimelineProps } from './RoadmapTimeline';
import { TeamCarousel, TeamCarouselProps } from './TeamCarousel';
import { PartnersList, PartnersListProps } from './PartnersList';
import { useState, useRef, useEffect } from 'react';
import { Optional } from 'utility-types';
import { useMobile } from 'src/hooks/useMobile';
import { ComingSoonText } from '../coming-soon/ComingSoonText';

const PARTNER_BLUMINT = {
  logoUrl:
    'https://firebasestorage.googleapis.com/v0/b/blumint-development.appspot.com/o/logo_transparent.png?alt=media&token=36a68473-8674-4db3-980a-c9bb9bf0ba35',
  name: 'BluMint',
};

export type RoadmapProps = Optional<
  RoadmapTimelineProps & TeamCarouselProps & PartnersListProps,
  'partners'
>;

export function Roadmap({
  nextPlans,
  team,
  partners,
  whitepaper,
}: RoadmapProps) {
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLElement>(null);
  const isMobile = useMobile();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    function onResize() {
      if (ref && ref.current) {
        setHeight(ref.current.clientHeight);
      }
    }
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  });

  return (
    <Box
      sx={{
        marginInline: 'auto',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {!isMobile ? (
        <>
          <Box sx={{ width: '416px' }}>
            <RoadmapTimeline
              whitepaper={whitepaper}
              nextPlans={nextPlans}
              maxHeight={height - 40}
            />
          </Box>
          <Stack
            gap="32px"
            sx={{
              gridArea: 'stack',
              marginLeft: '32px',
              width: 'calc(100vw - 416px - 64px)',
            }}
            ref={ref}
          >
            {!!team ? (
              <TeamCarousel team={team} />
            ) : (
              <ComingSoonText title={'Details of the team'} />
            )}

            <PartnersList partners={partners ? partners : [PARTNER_BLUMINT]} />
          </Stack>
        </>
      ) : (
        <Box
          sx={{
            width: 'min(588px, 100%)',
            marginInline: 'auto',
          }}
        >
          <ToggleButtonGroup
            value={activeTab}
            exclusive
            onChange={(_, value) => {
              if (value || value === 0) {
                setActiveTab(value);
              }
            }}
            size="small"
            sx={{ width: '100%', mb: 8, height: 40 }}
          >
            {['ROADMAP', 'TEAM', 'PARTNERS'].map((tab, i) => (
              <ToggleButton value={i} sx={{ width: '100%' }} key={tab}>
                {tab}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          {/* <Stack sx={{ flexDirection: 'row', gap: '15px', mb: '42px' }}>
            {['ROADMAP', 'TEAM', 'PARTNERS'].map((v, i) => (
              <GradientButton
                key={v}
                size="large"
                variant="outlined"
                fullWidth
                color="primary"
                onClick={() => setActiveTab(i)}
                sx={{
                  background: activeTab === i ? '#003170' : undefined,
                  ':hover': {
                    background: activeTab === i ? '#003170' : undefined,
                  },
                }}
              >
                {v}
              </GradientButton>
            ))}
          </Stack> */}
          <>
            {activeTab === 0 && (
              <RoadmapTimeline
                whitepaper={whitepaper}
                nextPlans={nextPlans}
                maxHeight={height - 40}
              />
            )}
            {activeTab === 1 &&
              (!!team ? (
                <TeamCarousel team={team} />
              ) : (
                <ComingSoonText title={'Details of the team'} />
              ))}
            {activeTab === 2 && (
              <PartnersList
                partners={partners ? partners : [PARTNER_BLUMINT]}
              />
            )}
          </>
        </Box>
      )}
    </Box>
  );
}
